import type { ErrorType } from '~/data/ErrorRecord';
import type { DIAMError } from '~/types/error-responses.types';

export const mapIAMErrorsToBFFErrors = (errors: DIAMError[]): ErrorType[] => {
  return errors.map((error) => {
    const description =
      error.code === '' ? 'web.login.error' : `diam.${error.code}`;

    return {
      description,
      id: description,
      status: error.status,
      detail: error.detail,
    };
  });
};
